import { render, staticRenderFns } from "./Rules.vue?vue&type=template&id=7d78c1c5&"
import script from "./Rules.vue?vue&type=script&lang=babel&"
export * from "./Rules.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports